module.exports = __webpack_public_path__ + "img/allergy_icon.fe62fc00.svg";